export const LANGUAGE_FAMILIES = Object.freeze({
    Spanish: 'Spanish',
    English: 'English',
    German: 'German',
    French: 'French',
    Dutch: 'Dutch',
    Swedish: 'Swedish',
    Italian: 'Italian',
    Danish: 'Danish',
    Dutch_Be: 'Dutch (Belgium)',
    French_Be: 'French (Belgium)',
})

export const LANGUAGE_SHORTCODES = Object.freeze({
    [LANGUAGE_FAMILIES.Spanish]: 'es',
    [LANGUAGE_FAMILIES.English]: 'en',
    [LANGUAGE_FAMILIES.German]: 'de',
    [LANGUAGE_FAMILIES.French]: 'fr',
    [LANGUAGE_FAMILIES.Dutch]: 'nl',
    [LANGUAGE_FAMILIES.Swedish]: 'sv',
    [LANGUAGE_FAMILIES.Italian]: 'it',
    [LANGUAGE_FAMILIES.Danish]: 'da',
    [LANGUAGE_FAMILIES.Dutch_Be]: 'nl',
    [LANGUAGE_FAMILIES.French_Be]: 'fr',
})

export const LANGUAGE_FAMILY_PREFIXES = Object.freeze({
    [LANGUAGE_FAMILIES.Spanish]: 'es_',
    [LANGUAGE_FAMILIES.English]: 'en_',
    [LANGUAGE_FAMILIES.German]: 'de_',
    [LANGUAGE_FAMILIES.French]: 'fr_',
    [LANGUAGE_FAMILIES.Dutch]: 'nl_',
    [LANGUAGE_FAMILIES.Swedish]: 'sv_',
    [LANGUAGE_FAMILIES.Italian]: 'it_',
    [LANGUAGE_FAMILIES.Danish]: 'da_',
    [LANGUAGE_FAMILIES.Dutch_Be]: 'nl_',
    [LANGUAGE_FAMILIES.French_Be]: 'fr_',
})

export const SUPPORTED_LANGUAGES = [
    LANGUAGE_FAMILIES.English,
    LANGUAGE_FAMILIES.German,
    LANGUAGE_FAMILIES.Spanish,
    LANGUAGE_FAMILIES.French,
    LANGUAGE_FAMILIES.Dutch,
    LANGUAGE_FAMILIES.Swedish,
    LANGUAGE_FAMILIES.Italian,
    LANGUAGE_FAMILIES.Danish,
    LANGUAGE_FAMILIES.Dutch_Be,
    LANGUAGE_FAMILIES.French_Be,
]



// WEBPACK FOOTER //
// ./src/modules/internationalization/languageConstants.js